import { createSelector } from '@reduxjs/toolkit';
import { FDealType } from '../../../packages/JsonQuery';
import { IPreloadedState } from 'shared/types/redux';
import { selectDealTypeFilter } from './selectDealTypeFilter';

const selectCounters = (state: IPreloadedState) => state.offers.data.counters;

export const selectCountersByDealType = createSelector(
  [selectDealTypeFilter, selectCounters],
  (dealType, { flatRentCounters, flatSaleCounters, dailyRentCounters }) => {
    switch (dealType) {
      case FDealType.Sale:
        return flatSaleCounters;

      /* istanbul ignore next */
      case FDealType.RentLongterm:
        return flatRentCounters;

      case FDealType.RentDaily:
        return dailyRentCounters;

      /* istanbul ignore next */
      default:
        return;
    }
  },
);
